import { styled } from 'linaria/react';

export const ComplementaryProductsBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ComplimentaryProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-250);
  width: 100%;
`;

export const AddedProductsTitle = styled.div`
  margin: var(--space-400) 0 var(--space-300) 0;
`;

export const ComplimentaryProductInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  width: 100%;
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: var(--space-75);
  width: 27.5%;
  margin-left: auto;

  & > div {
    justify-content: flex-end;

    @media (--only-mobile) {
      justify-content: flex-start;
    }
  }

  @media (max-width: 1100px) {
    width: 35.5%;
  }

  @media (--only-mobile) {
    align-items: flex-start;
    width: 100%;
  }
`;

export const VariantsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
